import { jsx as c } from "react/jsx-runtime";
import { c as d } from "./clsx-OuTLNxxd.js";
const h = "_block_1cfeo_29", e = {
  block: h,
  "is-centered": "_is-centered_1cfeo_35",
  "has-text-left": "_has-text-left_1cfeo_39",
  "has-text-centered": "_has-text-centered_1cfeo_43",
  "has-text-right": "_has-text-right_1cfeo_47",
  "has-text-justified": "_has-text-justified_1cfeo_51",
  "is-full-width": "_is-full-width_1cfeo_54",
  "dialog-overlay-show": "_dialog-overlay-show_1cfeo_1",
  "dialog-content-show": "_dialog-content-show_1cfeo_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1cfeo_1"
};
function u({
  children: i,
  isCentered: l = !1,
  textAlign: _ = "left",
  dangerouslySetInnerHTML: t = void 0,
  isFullWidth: a,
  className: f,
  ...s
}) {
  const o = d(
    e.block,
    l && e["is-centered"],
    e[n[_]],
    a && e["is-full-width"],
    f
  );
  return t ? /* @__PURE__ */ c("div", { className: o, ...s, dangerouslySetInnerHTML: t }) : /* @__PURE__ */ c("div", { className: o, ...s, children: i });
}
const n = {
  left: "has-text-left",
  center: "has-text-centered",
  right: "has-text-right",
  justify: "has-text-justified"
};
export {
  u as B,
  n as T
};
